////
/// ============================================================================
/// COMPONENT / Slider
/// ============================================================================
///
/// @link
/// @group components
////

// import Swiper JS
import Swiper from 'swiper';


// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default () => {
    let carousel3 = document.querySelector('.js-list-feature-carousel');

    if (carousel3) {
        const swiperCarousel3 = new Swiper(carousel3, {
            direction: "vertical",
            slidesPerView: 1,
            height: document.querySelector('.c-list-feature-carousel-text').offsetHeight,
            setWrapperSize: true,
            autoHeight: true,
            mousewheel: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    let carousel4 = document.querySelector('.js-carousel-card4');

    if (carousel4) {
        const swiperCarousel4 = new Swiper(carousel4, {
            slidesPerView: 1,
            loop: false,
            centeredSlides: false,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".js-carousel-card4-pagination",
                clickable: true,
            },
            breakpoints: {
                780: {
                    slidesPerView: 2,
                },
                922: {
                    slidesPerView: 3,
                },

                1420: {
                    slidesPerView: 4,
                },
            },
        });
    }

};
